import _ from 'lodash';
import { toLower, replace } from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PT from 'prop-types';
import {
  Icon,
  Table,
  Popup,
} from 'semantic-ui-react';
import Masonry from 'react-masonry-css';
import FiltersHeader from '../../components/FiltersHeader';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import TableControls from '../../components/TableControls';
import Link from '../../../lib/components/link';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import {
  selectWeeksWithPreSeasonForDropdown,
} from '../../../store/reducers/season';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { positionToTitle } from '../../../lib/lookups';
import { goToView } from '../../routes.global';
import {
  selectAuction10,
  selectAuction10State,
  AUCTION10_VIEW,
} from './module/auction10';
import { selectFormulas } from '../../../store/reducers/formula';
import { FormulaType } from '../../../lib/proptypes/formula';
import classes from './auction10.css';
import { PLAYER_VIEW } from '../Player/module/player';
import rookieIcon from '../../../assets/images/icon-rookie.png';
import upsideIcon from '../../../assets/images/upside.png';
import downsideIcon from '../../../assets/images/downside.png';
import analysisIcon from '../../../assets/images/icon-analysis.png';
import analysisIconUpdated from '../../../assets/images/icon-analysis-updated.png';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Fantasy Football Cheat Sheets: Huddle 10-Team Auction';

const mapStateToProps = state => {
  const { hasLoaded, year, week, formulaId } = selectAuction10State(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const loggedIn = state.auth.loggedIn;
  return {
    hasLoaded,
    selectedYear: year,
    selectedWeek: week,
    selectedProfile: formulaId,
    toolDescriptions,
    toolsLoaded,
    loggedIn,
    collapsed: selectControlsState(state).collapsed,
    ...hasLoaded && {
      auction10: selectAuction10(state),
      weeks: selectWeeksWithPreSeasonForDropdown(state, year, 'projections'),
      profiles: selectFormulas(state),
    },
  };
};
const actions = {
  goToView,
};
export class Auction10 extends PureComponent {
  static propTypes = {
    weeks: DropdownOptionsType,
    selectedProfile: PT.number,
    selectedWeek: PT.number,
    selectedYear: PT.number,
    auction10: PT.objectOf(PT.arrayOf(PT.shape({
      player_id: PT.number.isRequired,
      fname: PT.string.isRequired,
      lname: PT.string.isRequired,
      team: PT.string.isRequired,
      // fpts: PT.number.isRequired,
      bye: PT.number.isRequired,
      rank: PT.number.isRequired,
    }))),
    hasLoaded: PT.bool.isRequired,
    collapsed: PT.bool.isRequired,
    goToView: PT.func.isRequired,
    profiles: PT.arrayOf(FormulaType),
    toolsLoaded: PT.bool.isRequired,
    loggedIn: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  }

  static defaultProps = {
    weeks: [
      { key: 0, value: 0, text: 'Pre Season' },
    ],
    auction10: null,
    selectedWeek: null,
    selectedYear: null,
    selectedProfile: null,
    profiles: [],
    loggedIn: false,
  }

  state = {
    touchResize: true,
    prevLogin: false,
    didFirst: false,
  }

  /* Tier Names */
  // numeralNames = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT']

  changeAuction = () => {
    if (typeof window !== 'undefined') {
      let auction10 = this.props.auction10;
      let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      this.props.auction10 = clientWidth >= 985 ? {
        QB: auction10.QB,
        TE: auction10.TE,
        RB: auction10.RB,
        PK: auction10.PK,
        WR: auction10.WR,
        DF: auction10.DF,
      } : clientWidth < 605 ? {
        QB: auction10.QB,
        RB: auction10.RB,
        WR: auction10.WR,
        TE: auction10.TE,
        PK: auction10.PK,
        DF: auction10.DF,
      } : {
        QB: auction10.QB,
        WR: auction10.WR,
        PK: auction10.PK,
        RB: auction10.RB,
        TE: auction10.TE,
        DF: auction10.DF,
      };
      this.setState({ touchResize: !this.state.touchResize });
    }
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
    window.addEventListener('resize', this.changeAuction.bind(this));
    this.setState({ didFirst: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      const { selectedYear, selectedWeek, selectedProfile } = this.props;
      this.setState({ prevLogin: prevProps.loggedIn });
      if (this.props.loggedIn & this.props.auction10['QB'].length < 3 ) {
        window.location.reload();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.changeAuction.bind(this));
  }

  handleChangeYear = (event, { value }) => {
    const { selectedYear, selectedWeek, selectedProfile } = this.props;
    if (selectedYear !== value) {
      this.props.goToView(
        AUCTION10_VIEW,
        {
          params: { year: value, week: selectedWeek, formulaId: selectedProfile },
          updateQuery: false,
        },
      );
    }
  }

  handleChangeTimeFrame = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(AUCTION10_VIEW, { query: { week: value } });
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(AUCTION10_VIEW, { query: { formulaId: value } });
    }
  }

  renderPlayerRow = ({ player_id: id, rank, pcnt, fname, lname, team, bye, writeup, injured, rookie, upside, downside }) => {
    const name = `${fname} ${lname}`;
    const goPlayer = id => ({ type: PLAYER_VIEW, payload: { id, name: toLower(replace(fname + lname, /\./g, '')) } });

    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center">{pcnt}%</Table.Cell>
        <Table.Cell textAlign="center" className={classes.playerCell}>
            <Link
              to={goPlayer(id)}
              className={classes.playerName}
            >
              {name}
              {rookie==="Y" ? <img src={rookieIcon} alt="" className={classes.rookieIcon} /> : ""}
              {upside==="Y" ? <img src={upsideIcon} alt="" className={classes.upsideIcon} /> : ""}
              {downside==="Y" ? <img src={downsideIcon} alt="" className={classes.downsideIcon} /> : ""}
            </Link>

          {writeup
            ? <Popup
              trigger={<span className={classes.floatRight}><a role="button">{injured ? <Icon className={classes.injuryStatusIcon} name="plus" size="large" /> : <img src={analysisIcon} alt="" className={classes.analysisIcon} />}</a></span>}
              header={`${name} Analysis`}
              content={writeup}
              position="top center"
              wide
              on="hover"
              className={classes.analysisPopup}
              />
            : ""
          }
        </Table.Cell>
        <Table.Cell textAlign="center">{team}</Table.Cell>
        <Table.Cell textAlign="center">{bye}</Table.Cell>
      </Table.Row>
    );
  }

  renderTier = (tier, players) => {
    const playersByTier = players.filter(player => player.tier === tier);

    return (
      <fØ>
        { /* <Table.Row>
          <Table.Cell className="secondary-header" textAlign="center" colSpan="5">TIER {this.numeralNames[tier]}</Table.Cell>
        </Table.Row> */ }

        {playersByTier.map(player => this.renderPlayerRow(player))}
        </fØ>
    );
  }

  renderPositionTable = players => {
    const maxTier = players[players.length - 1].tier;
    const tiers = [];
    for (let i = 0; i < maxTier; i++) tiers.push(i + 1);

    const wrapperClass = classNames(
      classes.positionTable,
      { [classes.collapsed]: this.props.collapsed },
    );

    const playerPosition = players[0].position;

    return (
      <div className={wrapperClass} key={playerPosition}>
        <Table unstackable celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="table-title" colSpan="5" textAlign="center">
                {positionToTitle(playerPosition, { plural: true, uppercase: true })}
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell textAlign="center" className={classes.ffptsHeader}>Pcnt</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Player</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Team</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className={classes.byeHeader}>Bye</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {tiers.map(tier => this.renderTier(tier, players))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  render = () => {
    const {
      selectedYear,
      selectedWeek,
      selectedProfile,
      weeks,
      hasLoaded,
      toolDescriptions,
      toolsLoaded,
    } = this.props;

    // Always returns false if there's no data for index 0
    // const hasData = !!(auction10 && Object.values(auction10)[0].length);

    // Updated it to loop through the auction10 results until it finds at least one position w/data

    var { auction10 } = this.props;
    let printLink = '';

    let clientWidth = null;

    const hasData = !!(auction10 && typeof window !== 'undefined' && _.find(Object.values(auction10), position => position.length));

    if (typeof window !== 'undefined') {
      clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      auction10 = {
        QB: auction10.QB,
        RB: auction10.RB,
        WR: auction10.WR,
        TE: auction10.TE,
        PK: auction10.PK,
        DF: auction10.DF,
      };
    }

    if (hasData) {
      printLink = location.href.split('/');
      printLink.length = 3; // just need http://xxx.com
      printLink = printLink.join('/') + '/auction-10-team/' + selectedYear + '/' + selectedWeek + '/' + selectedProfile + '/false/print';
    }

    // Masonry Columns Breakpoints
    const breakpointColumns = {
      default: 3,
      999: 2,
      619: 1,
    };

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.auction10.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.auction10.text}
            />)}
          seasonType={selectedWeek === 0 ? 'preseasons' : 'seasons'}
          statType="projections"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          offFilters={false}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
          stacked
          printLink={clientWidth && clientWidth > 350 ? printLink : null}
        >
          <PrimaryDropdown
            label="Timeframe:"
            activeItem={selectedWeek}
            onChange={this.handleChangeTimeFrame}
            choices={weeks}
            className={classes.singleDropdown}
          />
        </FiltersHeader>

        <TableControls />

        <Masonry
          breakpointCols={breakpointColumns}
          className={classes.tablesWrapper}
          columnClassName={classes.tablesWrapperColumn}
        >
          {hasLoaded && hasData && Object.values(auction10).map(position =>
            position.length ? this.renderPositionTable(position) : null,
          )}
        </Masonry>

        {(hasLoaded && !hasData) && <h3>No data available for this period.</h3>}

      </div>
    );
  }
}
export default connect(mapStateToProps, actions)(Auction10);



// WEBPACK FOOTER //
// ./src/app/views/Auction10/Auction10.js